import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import uuid from "uuid";

import {discountInterFace, discountSectionsInterface} from "./discounstInterface";
import {setCustomAddedDiscounts, setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import DiscountDropdown from "../ui/dropdowns/discountDropdown";
import {getNextCustomDiscountOrder, shouldUseMultipleWorkSheets} from "./discountFunctions";

class DiscountNestedChild extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  discountDropdownClick = (dropdownItem) => {
    let updatedDiscounts = [...this.props.customAddedDiscounts];
    const alreadyExistingIndex = this.props.discount.uuId && updatedDiscounts.findIndex(discount => {
      return this.props.discount.uuId === discount.uuId;
    });
    if (alreadyExistingIndex > -1) { // just in case, should always be here!
      const updatedDiscount = dropdownItem.isEmpty ? updatedDiscounts[alreadyExistingIndex] : dropdownItem.discount;
      updatedDiscounts.splice(alreadyExistingIndex, 1, Object.assign({}, updatedDiscount, {
        selected: !dropdownItem.isEmpty,
        categoryId: this.props.discountSection.id,
        id: updatedDiscounts[alreadyExistingIndex].id,  // keep id
        order: updatedDiscounts[alreadyExistingIndex].order,  // keep order
        uuId: updatedDiscounts[alreadyExistingIndex].uuId,  // keep uuId
        quoteIndex: this.props.activeQuoteIndex,
      }))
    }
    this.props.setCustomAddedDiscounts(updatedDiscounts);
    this.props.setDiscountSections([...this.props.discountSections]); // update all price components
  }

  addNestedDiscountClick = () => {
    let updatedDiscounts = [...this.props.customAddedDiscounts];
    const lastSelectedNested = this.props.allSelectedNested[this.props.allSelectedNested.length - 1];
    const uuIdId = uuid();
    updatedDiscounts.push(Object.assign({}, this.props.nestedOptions[1], {
      selected: false,
      categoryId: this.props.discountSection.id,
      id: uuIdId,
      uuId: uuIdId,
      order: getNextCustomDiscountOrder(lastSelectedNested),
      quoteIndex: this.props.activeQuoteIndex,
    }));
    this.props.setCustomAddedDiscounts(updatedDiscounts);
    this.props.setDiscountSections([...this.props.discountSections]); // update all price components
  }

  render() {
    const {discount, nestedChildIndex, allSelectedNested, nestedOptions, parentDiscount} = this.props;

    const dropdownItems = nestedOptions.map(dis => {
      if (dis.isEmpty) {
        return {
          isEmpty: true,
          value: "None",
          text: "None",
          discount: nestedOptions[0],
          disabled: false
        }
      }
      return {
        value: dis.uuId,
        text: dis.name,
        discount: dis,
        disabled: this.isDiscountDisabled(dis)
      }
    })

    // console.log("allSelectedNested", allSelectedNested);
    // console.log("nestedChildIndex", nestedChildIndex);

    return (
      <li className={"discount"}>
        <div className="discount-cell discount-cell--select relative">
          <DiscountDropdown dropdownItems={dropdownItems}
                            dropdownTitle={"Select Discount"}
                            selectItemClick={this.discountDropdownClick}>
            <button className={"discount-nested__arrow-down"}/>
          </DiscountDropdown>
        </div>
        <div className="discount-cell discount-cell--name bold">
          {discount.selected ? discount.name : null}
          {discount.selected && parentDiscount.multiSelections
          && (allSelectedNested.length === 1 || (nestedChildIndex > 0)) && (nestedChildIndex === allSelectedNested.length - 1)
            ? <button className="discount-nested__plus-button margin-l-8" onClick={this.addNestedDiscountClick}/>
            : null}
        </div>
        {discount.selected ? (
          <div className="discount-cell discount-cell--amount bold">
            {this.getDiscountAmount()}
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setCustomAddedDiscounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountNestedChild);
